var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("form.success.headline")))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t("form.success.close")))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }